import api from "./client"

export function translateText(languageId: number, text: string) {
  return api.post<{ translation: string }>("/translations", {
    language_id: languageId,
    text,
  })
}
